import Model from 'scripts/poppet/model';

/**
 * defa.models.InsuranceCompany
 * The DEFA InsuranceCompany model
 * @version 1.2.0
 */
const InsuranceCompany = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	defaults: {
		name: '',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default InsuranceCompany;